import React from 'react'
import '../../../App.css'
import './About.css'
import AboutLinks from '../AboutLinks';

function Gospel() {
  return (
    <div>
        <div className='hero-container bible half'>
            <h1></h1>
         </div>
      <div className='main-grid-container'>
        <div className='main-grid-item'>
      <AboutLinks/>
      </div>
      <div className='main-grid-item'>
      <div className='main with-sublinks'>
        <h1>Gospel</h1>
        <h2>What does it mean to be a Christian?</h2>
        <p>
        Being a Christian is more than identifying yourself with a particular religion or affirming a certain value system. Being a Christian means you have received Christ as your Lord and Savior, believing what the Bible says about God, mankind, and salvation. <br/><br/>
        Consider the following truths found in Scripture:
        </p>
        <p>
          <strong>God Is Sovereign Creator. </strong> 
          Contemporary thinking says man is the product of evolution. But the Bible says we were created by a personal God to love, serve, and enjoy endless fellowship with Him. The New Testament reveals it was Jesus Himself who created everything (John 1:3; Colossians 1:16). Therefore, He also owns and rules everything (Psalm 103:19). That means He has authority over our lives and we owe Him absolute allegiance, obedience, and worship.
        </p>
        <p>
          <strong>God Is Holy. </strong>
          God is absolutely and perfectly holy (Isaiah 6:3), therefore He cannot commit or approve of evil (James 1:13). God requires holiness of us as well. 1 Peter 1:16 says, "You shall be holy, for I am holy." Because God is perfect, He cannot tolerate anything short of perfection from his creatures.
        </p>
        <p>
          <strong>Mankind Is Sinful. </strong>
          The great affliction affecting all mankind is that of sin. Sin is rebellion against a holy God—a failure to meet God’s perfect righteous standard. In our sin, we reject God’s wise and benevolent rule over our lives and seek to establish our own kingdoms as gods ourselves. According to Scripture, everyone is guilty of this rebellion: "There is no man who does not sin" (1 Kings 8:46). That doesn’t mean we’re incapable of performing acts of human kindness or goodness, but it does mean we’re utterly incapable of understanding, loving, or pleasing God in our natural, sinful condition. (Romans 3:10-12).
        </p>
        <p>
          <strong>Sin Demands a Penalty. </strong>
          God’s holiness and justice demand that all sin be punished by eternal death (Ezekiel 18:4; Romans 6:23). Just like a human judge is required to punish evil acts of lawlessness, so too must God—the supreme Judge of all—punish those who break His perfect, holy law.
        </p>
        <p>
          <strong>Jesus Is Lord and Savior. </strong>
          The New Testament reveals it was Jesus Himself who created everything (Colossians 1:16). Therefore He owns and rules everything (Psalm 103:19, Matthew 28:18). That means He has total authority over our lives and we owe Him absolute allegiance, obedience, and worship. Romans 10:9 says, “If you confess with your mouth Jesus as Lord, and believe in your heart that God raised Him from the dead, you shall be saved.” Even though God’s justice demands death for sin, His love has provided a Savior who paid the penalty and died for sinners (1 Peter 3:18). Christ’s death satisfied the demands of God’s justice and Christ’s perfect life satisfied the demands of God’s holiness (2 Corinthians 5:21), thereby enabling Him to forgive and save those who place their faith in Him (Romans 3:26).
        </p>
        <p>
          <strong>The Character of Saving Faith. </strong>
          True faith is always accompanied by repentance from sin. Repentance is agreeing with God that you are sinful, confessing your sins to Him, and making a conscious choice to turn from sin (Luke 13:3,5; 1 Thessalonians 1:9) and pursue Christ in obedience. (John 17:3, 1 John 2:3). It isn’t enough to believe certain facts about Christ. Even Satan and his demons believe in the true God (James 2:19), but they don’t love and obey Him. True saving faith always responds in obedience (Ephesians 2:10).
        </p>
        <p className='text-muted'>
          <em>
          If you have questions about how you can become a Christian, or want help in knowing how to live the Christian life, please get in contact with us.  
          </em>
        </p>
      </div>
      </div>
      </div>
    </div>
  )
}

export default Gospel
